//basic
import React, { Component } from 'react';
import { toJS } from 'mobx';
import { observer, inject } from 'mobx-react';

//style
import './Shops.scss';

//api
import { api } from '../../../functions/api';

//custom components
import CustomTable from '../../../components/complex/customTable';
import Search from '../../../components/basic/search';
import CustomButton from '../../../components/basic/CustomButton';

// import ChangeSiblingsPositions from './ChangeSiblingsPositions/ChangeSiblingsPositions';
import AddEditItem from '../AddEditItem/AddEditItem';
import DeleteDialog from '../../../components/global/deleteDialog';

//material-ui
import { CircularProgress, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';

//other libraries
import queryString from 'query-string';
import Icon from '@mdi/react';
import { mdiPlus } from '@mdi/js';

@inject('internal')
@inject('translate')
@observer
export default class Shops extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingPage: true,
            addEditDialog: false,
        }
    }

    dropDownMenuItems = [
        {
            title: this.props.translate.i18n.MODULES.ADMINISTRATORS.MENU_ITEMS.EDIT,
            // action: "edit",
            url: 'basic'
        },
        // {
        //     title: this.props.translate.i18n.GLOBAL.BUTTONS.DELETE,
        //     action: "delete"
        // },
    ]

    tableHeader = [
        {
            "title": "name",
            "numeric": false,
            "min_width": "150px",
            
        },
        {
            "title": "url",
            "numeric": false,
            "min_width": "150px",
            
        },
        {
            "title": "production",
            "numeric": false,
            "textAlign": "center"
        },
    ];
    tableBody = [
        "name",
        "url",
        "production",
    ]

    componentDidMount() {
        const { user } = toJS(this.props.internal)

        if(user && user.data && user.data.permissions && user.data.permissions.lists_shops && user.data.permissions.lists_shops.view) {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname);
            this.props.internal.setHeaderTitle(this.props.translate.i18n.GLOBAL.MENU.GIFTS);
            // this.setPermissions()
            this.loadShops()
            
        }
        else {
            this.props.internal.setRoute(this.props.history, this.props.location.pathname)
            this.props.internal.pushRoute('/')
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.NOT_PERMISSIONS, true)
        }
        
    }

    loadShops = async() => {
        // this.setState({loadingPage: true})
        
        let params = {}

        let load_data = await api({
            method:'get',
            url: 'lists/shops',
            authorization: this.props.internal.user.access_token,
            params: params
        })
        if (load_data.success === true) {
            if (load_data.data) {
                this.props.internal.setDataForTable(load_data.data)
            }
        }
        this.setState({loadingPage: false})
    }

    handleDelete = async () => {
        let idShop = toJS(this.props.internal.actionDeleteObj.id)
        let delete_shop = await api({
            method: 'delete',
            url: `lists/shops/${idShop}`,
            authorization: this.props.internal.user.access_token,
        });

        if(delete_shop.success === true) {
            this.props.internal.setSnackbar(delete_shop.data.message, true)
            this.loadShops();
            this.props.internal.setActionDelete();
        }
    }

    changeProductionStatus = async(id, status) => {

        let update_data = await api({
            url: `lists/shops/${id}`,
            method: 'patch',
            authorization: this.props.internal.user.access_token,
            params: {
                production: status
            }
        })

        if(update_data.success === true) {
            this.props.internal.setSnackbar(update_data.data.message, true)
            this.loadShops()
        }
        else {
            this.props.internal.setSnackbar(update_data.data.message, true)
        }
    }

    handleOpenCloseDialog = async(refresh = false) => {
        
        let actionEdit = toJS(this.props.internal.actionEdit)
        if(actionEdit.edit) {
            actionEdit = {
                edit: false,
                id: null
            }
            this.props.internal.setActionEdit(actionEdit)
        }
        else {
            this.setState({addEditDialog: !this.state.addEditDialog})
        }

        if(refresh) {
            this.loadShops()
        }
    }

    render () {
        const { user } = toJS(this.props.internal)
        return (
            this.state.loadingPage
                ?
                <CircularProgress className={'circular-progress'}/>
                :
                <div className={'shopsContainer'}>
                    <DeleteDialog
                        open={this.props.internal.actionDelete}
                        title={this.props.translate.i18n.MODULES.SHOPS.DELETE_SHOP_TITLE}
                        content={this.props.translate.i18n.GLOBAL.ALERTS.DELETE_ITEM}
                        btn_cancel={this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                        btn_delete={this.props.translate.i18n.GLOBAL.BUTTONS.DELETE}
                        delete={this.handleDelete}
                    />
                    {/* {(this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)) &&
                        <AddEditItem
                            open={this.state.addEditDialog || toJS(this.props.internal.actionEdit.edit)}
                            onClose={this.handleOpenCloseDialog}
                            title={this.state.addEditDialog ? this.props.translate.i18n.MODULES.SHOPS.DIALOG_TITLE_CREATE : this.props.translate.i18n.MODULES.SHOPS.DIALOG_TITLE_EDIT}
                            typeMenu={this.state.typeMenu}
                            setMenuPosition={this.setMenuPosition}
                            shop={this.state.shop_id}
                        />
                    } */}

                    <div className={'flex space-between'}>
                        <Search placeholder={this.props.translate.i18n.MODULES.MENU.SEARCH} classes={'admin-search'} onChange={this.handleSearch} value={this.state.searchTerm}/>
                        {/* {user && user.data && user.data.permissions && user.data.permissions.lists_shops && user.data.permissions.lists_shops.store ?
                            <CustomButton
                                mystyle = {'btn-orange-bg border-radius-18'}
                                title = {this.props.translate.i18n.MODULES.SHOPS.CREATE_NEW_SHOP}
                                onClick = {this.handleOpenCloseDialog}
                            >
                                <Icon path = {mdiPlus} size = {1}/>
                            </CustomButton>
                            :
                            null
                        } */}
                    </div>
                    <CustomTable
                        dropDownMenuItems={this.dropDownMenuItems}
                        module={'/shops'}
                        handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                        handleChangePage={this.handleChangePage}
                        handleSort={this.handleSort}
                        header={this.tableHeader}
                        body={this.tableBody}
                        // openDialogSiblings={this.openCloseDialogChangePosition}
                        // updateTypeMenuItem={this.updateTypeMenuItem}
                        clickOnProductionStatus={this.changeProductionStatus}
                        disablePagination
                        disableSort
                    />
                </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/shops/list/Shops.jsx